module.exports = __webpack_public_path__ + "assets/86841f6381781e2295720ace298385f2.png";